import { render, staticRenderFns } from "./Adjustments.vue?vue&type=template&id=2a0ede45"
import script from "./Adjustments.vue?vue&type=script&lang=js"
export * from "./Adjustments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports